import ApplicationComponent from "legacy/ApplicationComponent"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class SegmentedControl extends ApplicationComponent {
  style() {
    const styles = {
      gray: {
        selectedButtonClass: "bg-white text-gray-700",
        unselectedButtonClass: "bg-gray-200 hover:bg-gray-300 text-gray-700",
        separatorClass: "bg-gray-400",
        backgroundClass: "bg-gray-200",
      },
      teal: {
        selectedButtonClass: "bg-teal-700 text-white",
        unselectedButtonClass: "bg-teal-200 hover:bg-teal-300 text-teal-700",
        separatorClass: "bg-teal-400",
        backgroundClass: "bg-teal-200",
      },
      blue: {
        selectedButtonClass: "bg-blue-700 text-white",
        unselectedButtonClass: "bg-blue-200 hover:bg-blue-300 text-blue-700",
        separatorClass: "bg-blue-400",
        backgroundClass: "bg-blue-200",
      },
    }
    return styles[this.props.style]
  }

  buttonClass(segment) {
    return this.props.selectedSegment === segment.id
      ? `w-full font-bold text-xs lg:text-sm rounded ${
          this.style().selectedButtonClass
        }`
      : `w-full font-bold rounded ${this.style().unselectedButtonClass}`
  }

  renderButtons() {
    return _.map(this.props.segments, (segment) => {
      return (
        <div className="flex w-full space-x-1" key={segment.id}>
          <button
            className={this.buttonClass(segment)}
            type="button"
            key={segment.id}
            id={segment.id}
            onClick={(event) => this.props.handleSelection(event.target.id)}
          >
            {segment.title}
          </button>
          {segment.id !==
            this.props.segments[this.props.segments.length - 1].id && (
            <div className={`${this.style().separatorClass} m-1 w-px`} />
          )}
        </div>
      )
    })
  }

  render() {
    return (
      <div
        id={this.props.id}
        className={`mb-3 inline-flex h-10 w-full space-x-1 rounded p-1 ${
          this.style().backgroundClass
        }`}
      >
        {this.renderButtons()}
      </div>
    )
  }
}

SegmentedControl.propTypes = {
  id: PropTypes.string,
  selectedSegment: PropTypes.string.isRequired,
  segments: PropTypes.array.isRequired,
  handleSelection: PropTypes.func.isRequired,
  style: PropTypes.string,
}

export default SegmentedControl
